"use client";

import React, { useEffect } from "react";

import Sites from "../../constants/Sites";
import { useAppContext } from "@components/Provider";

import styles from "./SingleColumnLayoutWithOutHeaderFooter.module.css";
import "./GlobalLayout1.css";
import TagManager from 'react-gtm-module';

const SingleColumnLayoutWithOutHeaderFooter = (props) => {
  const { siteId, isMobile, subscriberCookie, data } = useAppContext();

  useEffect(() => {
    if (!data?.SiteSettings?.gtm_container_id) return;

    // Delay GTM init until layout and page state are stable
    const id = data.SiteSettings.gtm_container_id;

    requestAnimationFrame(() => {
      TagManager.initialize({ gtmId: id });
    });
  }, [data?.SiteSettings?.gtm_container_id]);

  return (
    <React.Fragment>
      <div
        className={[styles["container"], "container"].join(" ")}
        style={{
          "--top-padding-1024": !subscriberCookie ? "58px" : isMobile ? "25px" : "48px",
          "--top-padding-712": !subscriberCookie ? siteId == Sites.EARLYBIRDBOOKS ? "0" : "15px" : "15px",
        }}
      >
        {props.children}
      </div>
    </React.Fragment>
  );
};

export default SingleColumnLayoutWithOutHeaderFooter;
